<template>
  <div class="text-page">
    <vue-headful :title="doctitle" />
    <b-container>
      <b-row>
        <b-col>
          <h1>Join one of the Øredev side events!</h1>
          <p>
            Get ready for an unforgettable Øredev experience with our lineup of
            side events! These events are designed to provide you with
            additional opportunities to network, learn and have fun outside the
            main conference schedule. All attendees are welcome to join the side
            events happening during the Øredev week.
          </p>
          <p class="mb-0">
            Please note that each event may have specific registration policies,
            participation limits and requirements. Be sure to read the details
            for each event before signing up.
          </p>
        </b-col>
      </b-row>

      <DividerPink />
    </b-container>

    <div class="margin-images-container">
      <b-container style="max-width: 1214px">
        <OredevPlusEvents />
      </b-container>
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/Shape_blue.png"
        class="mobile-image"
        alt=""
        aria-hidden="true"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/Shape_orange.png"
        class="position-absolute gutter-image"
        style="width: 8%; right: 9%; top: -15%"
        alt=""
        aria-hidden="true"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/planet.png"
        class="position-absolute gutter-image"
        style="width: 14%; left: 1%; top: -8%"
        alt=""
        aria-hidden="true"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/eye.png"
        class="position-absolute gutter-image"
        style="width: 10%; left: 4%; top: 64%"
        alt=""
        aria-hidden="true"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/Shape_blue.png"
        class="position-absolute gutter-image"
        style="width: 8%; right: 10%; top: 99%"
        alt=""
        aria-hidden="true"
      />
    </div>
  </div>
</template>
  
<script>
import OredevPlusEvents from "@/components/OredevPlusEvents.vue";
export default {
  name: "OredevPlusV2",
  components: { OredevPlusEvents },
  data() {
    return {
      doctitle: "Øredev+ - " + this.$store.state.conferencename,
    };
  },
};
</script>
  
<style lang="scss" scoped>
.margin-images-container {
  max-width: 1900px;
  position: relative;
  margin: 0 auto;
  @media (min-width: 1850px) {
    margin-bottom: 260px;
  }
  .mobile-image {
    display: none;
  }
  @media (max-width: 1850px) {
    .gutter-image {
      display: none;
    }
    .mobile-image {
      display: block;
      min-width: 120px;
      width: 8%;
      margin: 0 auto;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/OredevPlusV2.vue